import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetPhoneState } from '@store/modules/phone';

@Injectable({
  providedIn: 'root'
})
export class SmartphoneFacadeService {
   readonly #store = inject(Store);

   reset() {
    this.#store.dispatch(resetPhoneState());
   }
}
